import buildFilter from './entityRequest/buildFilter';
import buildProvenances from './entityRequest/buildProvenances';
import convertDynamicRefinersToRefiners from './entityRequest/convertDynamicRefinersToRefiners';
import convertItemTypesToEntityType from './entityRequest/convertItemTypesToEntityType';
import ExecuteSearchJsonRequest from 'owa-service/lib/contract/ExecuteSearchJsonRequest';
import mapSortOrdering from './entityRequest/mapSortOrdering';
import { EntityRequest, SearchQuery } from '../../../data/schema/SubstrateSearchRequest';

/**
 * Creates value for EntityRequest property of 3S query request.
 */
export default function createEntityRequests(
    request: ExecuteSearchJsonRequest,
    queryIncludesPeopleSuggestion: boolean,
    pageNumber: number,
    actionSource: string
): EntityRequest[] {
    /**
     * Enable query processing from service for first pages of query requests
     * and if the search was not initiated from a query alteration recourse link.
     */
    const shouldServiceProcessQuery =
        pageNumber === 0 && actionSource !== 'QueryAlterationRecourseLink';

    const entityRequests: EntityRequest[] = [
        {
            EntityType: convertItemTypesToEntityType(request.Body.ItemTypes),
            Filter: buildFilter(request),
            From: request.Body.ResultRowOffset,
            PropertySet: 'ProvenanceOptimized',
            Provenances: buildProvenances(request),
            Query: createQuery(request, queryIncludesPeopleSuggestion),
            QueryAlterationOptions: {
                // Flag to enable low confidence alterations in 3S
                EnableSuggestion: shouldServiceProcessQuery,
                // Flag to enable medium/high confidence alterations in 3S
                EnableAlteration: shouldServiceProcessQuery,
            },
            RefiningQueries: convertDynamicRefinersToRefiners(request.Body.SearchRefiners),
            Size: request.Body.ResultRowCount,
            Sort: mapSortOrdering(request.Body.SortOrder),
        },
    ];

    return entityRequests;
}

/**
 * Creates the Query property of the EntityRequest object.
 */
function createQuery(
    request: ExecuteSearchJsonRequest,
    queryIncludesPeopleSuggestion: boolean
): SearchQuery {
    /**
     * If the query includes a people suggestion (thus includes KQL), we add
     * extra properties to the Query object so that the KQL isn't added to the
     * user's search history.
     */
    if (queryIncludesPeopleSuggestion) {
        return {
            QueryString: request.Body.Query,
            DisplayQueryString: '' /* Intentionally empty so nothing is added to search history. */,
            ClientQueryAlterationReasons: 'PeopleSearch Scenario',
        };
    } else {
        return {
            QueryString: request.Body.Query,
        };
    }
}
